import * as Yup from 'yup';

import { onlyNumbers } from 'shared/utils/formatters';
import { isValidCNPJ, isValidCPF } from 'shared/utils/validation';
import {
  isNotTodayOrFuture,
  isOver18,
  isValidDate,
} from 'features/checkout/utils/dateUtils';

export const maxLimitMessage = (length: number) =>
  `Limite de ${length} caracteres`;

export const onlyLetters = (value: string) =>
  value.replace(/[^A-Za-zÀ-ÿ\s]/g, '');

export const validationAddressForm = Yup.object({
  person_type: Yup.string().required(),
  responsible: Yup.string()
    .max(120, maxLimitMessage(120))
    .required('Campo obrigatório')
    .when('person_type', {
      is: 'pj',
      then: Yup.string().test(
        'has-two-names',
        'Informe razão social composta (mínimo dois nomes)',
        (value) => !!value && value.trim().split(/\s+/).length >= 2,
      ),
      otherwise: Yup.string().test(
        'has-two-names',
        'Informe nome e sobrenome',
        (value) => !!value && value.trim().split(/\s+/).length >= 2,
      ),
    }),
  cpf_cnpj: Yup.string().when('person_type', {
    is: 'pj',
    then: Yup.string()
      .required('CNPJ obrigatório')
      .test('is-valid-cnpj', 'CNPJ inválido', (value) =>
        isValidCNPJ(onlyNumbers(value ?? '')),
      ),
    otherwise: Yup.string()
      .required('CPF obrigatório')
      .test('is-valid-cpf', 'CPF inválido', (value) =>
        isValidCPF(onlyNumbers(value ?? '')),
      ),
  }),
  billing_address: Yup.string()
    .max(255, maxLimitMessage(255))
    .required('Endereço obrigatório'),
  billing_number: Yup.string()
    .matches(/^\d+$/, 'Apenas números')
    .max(20, maxLimitMessage(20))
    .required('Número obrigatório'),
  billing_address2: Yup.string()
    .nullable()
    .notRequired()
    .test(
      'max-length-if-filled',
      maxLimitMessage(255),
      (value) => !value || value.length <= 255,
    ),
  billing_neighborhood: Yup.string()
    .max(30, maxLimitMessage(30))
    .required('Bairro obrigatório'),
  billing_city: Yup.string()
    .max(255, maxLimitMessage(255))
    .required('Cidade obrigatória'),
  billing_state: Yup.string().required('Estado obrigatório'),
  billing_zip: Yup.string().required('CEP obrigatório'),
  billing_birthdate: Yup.string().when('person_type', {
    is: 'pf',
    then: Yup.string()
      .required('Data de Nascimento obrigatória')
      .matches(/^\d{2}\/\d{2}\/\d{4}$/, 'Formato deve ser DD/MM/AAAA')
      .test('is-valid-date', 'Data inválida', isValidDate)
      .test('is-18', 'Deve ser maior de 18 anos', isOver18)
      .test(
        'not-today-or-future',
        'Data de Nascimento inválida',
        isNotTodayOrFuture,
      ),
  }),
});
